import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { MaterialModule } from 'src/app/shared/MaterialAngular/material.module';
import { AppLayoutModule } from 'src/app/shared/app-layout/app-layout.module';
import { HomeDashboardComponent } from './home-dashboard/home-dashboard.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HomeMetricsComponent } from './components/home-metrics/home-metrics.component';
import { HomeTabsNavComponent } from './components/home-tabs-nav/home-tabs-nav.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
@NgModule({
  declarations: [
    HomeComponent,
    HomeDashboardComponent,
    HomeTabsNavComponent,
    HomeMetricsComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    MaterialModule,
    AppLayoutModule,
    RouterModule,
    FormsModule,
    NgxChartsModule
  ]
})
export class HomeModule { }
